import { FieldNumberOutlined, FormOutlined, LockOutlined, PaperClipOutlined, PhoneOutlined, UserOutlined } from '@ant-design/icons';
import { Form, Input } from "antd";
import { User } from "../../apis/mgmt/api";
import { DataForm } from "../common/DataForm";
import { DataViewProps } from "../common/DataView";
import { PermissionSectionList, usePermissionListByUser } from '../permission/PermissionList';

export const UserForm = function (
    props: DataViewProps<User>
) {

    const user = props.data;
    const userId = user?.id;
    const permissionList = usePermissionListByUser({ userId })['listProps'];
    const permissionDefault = { user };

    const onValuesChange = (data: User) => {
        if (!data?.password && data.password!==undefined) data.password = undefined;
    }

    return (<>
        <DataForm {...props} onValuesChange={onValuesChange}>
            {/* id */}
            <Form.Item
                className="input"
                name="id"
            >
                <Input prefix={<FieldNumberOutlined className="site-form-item-icon" />} placeholder="ID" disabled={true} />
            </Form.Item>

            {/* username */}
            <Form.Item
                className="input"
                name="username"
                rules={[{ required: true, message: '¡Please input the Username!' }]}
            >
                <Input prefix={<UserOutlined className="site-form-item-icon" />} placeholder="Username" />
            </Form.Item>

            {/* Email */}
            <Form.Item
                className="input"
                name="email"
                rules={[{ required: true, message: '¡Please input your Email!' }, {
                    type: "email",
                    message: "This field must be a valid email."
                }]}
            >
                <Input prefix={<PaperClipOutlined className="site-form-item-icon" />} placeholder="Email" />
            </Form.Item>

            <Form.Item
                className="input"
                name="password"
                rules={
                    props.data?.id ? [] :
                    [
                        { required: true, message: '¡Please input your password!' }, 
                    ]
                }
            >
                <Input prefix={<LockOutlined className="site-form-item-icon" />} placeholder="Password" />
            </Form.Item>

            <Form.Item className="input" name="firstName" required={true}>
                <Input prefix={<FormOutlined className="site-form-item-icon" />} placeholder="First Name" />
            </Form.Item>

            <Form.Item className="input" name="lastName" >
                <Input prefix={<FormOutlined className="site-form-item-icon" />} placeholder="Last Name" />
            </Form.Item>

            <Form.Item className="input" name="phone" >
                <Input prefix={<PhoneOutlined className="site-form-item-icon" />} placeholder="Phone" />
            </Form.Item>

        </DataForm>

        <PermissionSectionList listProps={permissionList} defaultAddItemData={permissionDefault} />
    </>);

};
